export default "__VITE_ASSET__Ay39YumD__"